import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Flex, { GAP_CLASS } from "components/Flex";
import { ALIGN_CLASS } from "components/Flex/Flex";
import { modalTypes } from "constants/types";
import { number, string } from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideModal } from "slices/app/actions/modals";
import { unarchiveProposal } from "slices/proposals/list/actions";

import classes from "./UnarchiveProposalModal.module.scss";

const SCOPE = {
  PROPOSAL_ONLY: "proposal_only",
  PROPOSAL_AND_OPPORTUNITY: "proposal_and_opportunity",
};

const UnarchiveProposalModal = ({ proposalId, proposalTitle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedScope, setSelectedScope] = useState(null);

  const handleClose = () => dispatch(hideModal(modalTypes.UNARCHIVE_PROPOSAL));

  const handleSubmit = async () => {
    const includeOpportunity = selectedScope === SCOPE.PROPOSAL_AND_OPPORTUNITY;
    try {
      await dispatch(unarchiveProposal(proposalId, includeOpportunity));
      handleClose();
      navigate("/proposals/archived");
    } catch {
      handleClose();
    }
  };

  return (
    <Modal show centered backdrop onDismiss={handleClose} className="fade-in">
      <Modal.Header>Unarchiving</Modal.Header>
      <Modal.Body className={classes.unarchive_proposal_modal}>
        <p>
          You are about to unarchive <strong>{proposalTitle}</strong>.
        </p>
        <p>Choose how you want to proceed:</p>
        <Flex
          className={classes.unarchive_proposal_modal__options}
          alignItems={ALIGN_CLASS["flex-start"]}
          gap={GAP_CLASS.GAP_200}
        >
          <label className={classes.unarchive_proposal_modal__options__option}>
            <input
              type="radio"
              name="scope"
              value={SCOPE.PROPOSAL_ONLY}
              checked={selectedScope === SCOPE.PROPOSAL_ONLY}
              onChange={() => setSelectedScope(SCOPE.PROPOSAL_ONLY)}
            />
            Unarchive this proposal only
          </label>
          <label className={classes.unarchive_proposal_modal__options__option}>
            <input
              type="radio"
              name="scope"
              value={SCOPE.PROPOSAL_AND_OPPORTUNITY}
              checked={selectedScope === SCOPE.PROPOSAL_AND_OPPORTUNITY}
              onChange={() => setSelectedScope(SCOPE.PROPOSAL_AND_OPPORTUNITY)}
            />
            Unarchive this proposal and the associated tracked opportunity
          </label>
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <NewButton variant={NewButtonVariant.l6} onClick={handleClose}>
          Cancel
        </NewButton>
        <NewButton
          variant={NewButtonVariant.l1}
          disabled={!selectedScope}
          onClick={handleSubmit}
        >
          Unarchive
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

UnarchiveProposalModal.propTypes = {
  proposalId: number.isRequired,
  proposalTitle: string.isRequired,
};

export default UnarchiveProposalModal;
